module.exports = __webpack_public_path__ + "static/media/alert1.6a53bda1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/alert1.mp3
// module id = 1599
// module chunks = 0